import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from '@/plugins/router'
import store from '@/plugins/store/index'
import axios from '@/plugins/axios'
import message from '@/components/app/classes/Message'
import i18n from '@/plugins/i18n'
import VueSessionStorage from "vue-sessionstorage";
import dayjs from 'dayjs';
import * as FullStory from '@fullstory/browser';

import {VueMaskDirective} from 'v-mask';
import frag from 'vue-frag';

import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.directive('frag', frag);
Vue.directive('mask', VueMaskDirective);
require('dayjs/locale/es');
const relativeTime = require('dayjs/plugin/relativeTime');
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);

Vue.use(VueSessionStorage);

dayjs.locale('es');
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$axios = axios;
Vue.prototype.$Message = message;
Vue.config.productionTip = false
axios.init();

store.dispatch("security/verifyJwt", () => {/*TODO ADD INITIAL BEHAVIOR */
});

FullStory.init({orgId: '17WVJB'});
Vue.prototype.$FS = FullStory;

new Vue({
    vuetify, router, store: store, i18n,
    render: h => h(App), data: {fontSize: 1},
}).$mount('#app')
